// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2eT4O","title":"AfterBackImages_title__1sGRN","images":"AfterBackImages_images__2Z5pZ"};